module.exports = __webpack_public_path__ + "static/media/rewards-scan.947af583.svg";